import * as API from '../../utils/api'

export const validateEmail = async values => {
  let result = await API.validateEmail(values.email)

  if (!result.data.available) {
    throw {
      email: 'This email is already in use',
    }
  }
}
